import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import consignacionPdf from "../../../../Pdf/consignacionPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class MandarConsignacion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "consignaciones/datosPdf",
        { consignacionId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if(res.data?.correosEnvio?.length > 0){
          this.formRef.current.setFieldsValue({correosEnvio: res.data.correosEnvio})
        }
        const pdf = pdfMake.createPdf(consignacionPdf(res.data));
        this.setState(
          {
            loading: false,
            pdf: pdf,
          },
          () => {
            pdf.open({}, window.frames["consignacionPdf"]);
          }
        );
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    message.error("Revisa que los datos sean correctos");
  }
  onFinish(values) {
    if(values?.correosEnvio?.length > 0){
    this.setState({ loading: true });
    axios
      .post(
        "consignaciones/enviarConsignacion",
        { ...values, consignacionId: this.props.id, empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Consignacion enviada");
          this.formRef.current.resetFields();
          this.cerrarMandarConsignacion();
        } else if (res.data.success === 1) {
          message.error("No se pudo enviar la consignacion a ese correo");
        } else {
          message.error("Sucedio un error y no se pudo enviar");
        }
      });
    }else{
      message.info('Proporcione al menos un correo de envio')
    }
  }
  cerrarMandarConsignacion() {
    this.props.cerrarMandarConsignacion();
    this.formRef.current.resetFields()
  }
  render() {
    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarMandarConsignacion.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarConsignacion"
          layout
          width={700}
          onCancel={this.cerrarMandarConsignacion.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
        <FormInitial.List
          name="correosEnvio"
          initialValue={[{correo: ''}]}
        >
          {(fields, { add, remove }) => (
            <>
              {fields.map(({name}, arrayKey) => (
                <Row>
                  <Col span={22}>
                  <FormItem
                    name={[name, "correo"]}
                    fieldKey={[arrayKey, "correo"]}
                    label='Correo'
                    required
                    margin
                    email
                    pattern
                  >
                    <InputItem style={{width: '100%'}} placeholder="Correo" />
                  </FormItem>
                  </Col>
                  <Col span={2}>
                    <div style={{textAlign: 'center'}}>
                      <MinusCircleOutlined
                          onClick={() => remove(name)}
                        />
                    </div>
                  </Col>
                </Row>
              ))}
              {fields.length <5 ?
              <div style={{textAlign: 'center', marginTop: '5px'}}>
                <ButtonItem
                  type="primary"
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                >
                  Agregar
                </ButtonItem>
                </div>
              : null}
            </>
          )}
        </FormInitial.List>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Mandar Correo
            </ButtonItem>
              <ButtonItem
              type="primary"
              danger
              onClick={this.cerrarMandarConsignacion.bind(this)}
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Cancelar
            </ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe
          title={"consignacion"}
          style={{ width: "100%", height: "100vh" }}
          id="consignacionPdf"
          name="consignacionPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(MandarConsignacion);
